// File Metadata:
// Filename: TaskBoard.js
// Version: 1.00
// Created: 2022-11-19 01:00:41
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Grid, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { useGetReceptionsQuery } from '../api/receptionsApiSlice'
import { useGetShipmentlogsQuery } from '../api/shipmentlogsApiSlice'
import React, { useState } from 'react'
import useAuth from '../../hooks/useAuth'

import Task from './Task'

/* 
    - Pull unfinished tasks from receptions and tasks and show them on cards
    - Show tasks based on assigned roles
    - Coworkers can be assigned tasks 
    - Admin/Manager/Voorman/Coordinator can see all tasks that everybody is working on.
    - Coworkers can check of completed tasks

*/

const TaskBoard = () => {
	
	let content
	const { username, isVoorman, isAdmin } = useAuth()
	const {
		data: receptions,
		isLoading: isLoadingReceptions,
		isSuccess: isSuccessReceptions,
		isError: isErrorReceptions,
		error: errorReceptions
	} = useGetReceptionsQuery('receptionsList', {
		pollingInterval: 15000,
		refetchOnFocus: true,
		refetchOnMountOrArgChange: true
	})

	const {
		data: shipmentlogs,
		isLoading: isLoadingShipments,
		isSuccess: isSuccessShipments,
		isError: isErrorShipments,
		error: errorShipments
	} = useGetShipmentlogsQuery('shipmentlogsList', {
		pollingInterval: 15000,
		refetchOnFocus: true,
		refetchOnMountOrArgChange: true
	})

	const [putawayFilter, setPutawayFilter] = useState('ALL')

	// Combined loading state
	if (isLoadingReceptions || isLoadingShipments) {
		return <p>Loading...</p>
	}

	// Combined error state
	if (isErrorReceptions || isErrorShipments) {
		return <p className='errmsg'>
			{errorReceptions?.data?.message || errorShipments?.data?.message}
		</p>
	}

	// Success state when both queries complete
	if (isSuccessReceptions && isSuccessShipments) {
		const { ids: receptionIds, entities: receptionEntities } = receptions
		const { ids: shipmentIds, entities: shipmentEntities } = shipmentlogs

		// Filter receptions based on putawayStatus
        let filteredReceptionIds = [...receptionIds]
        if (putawayFilter !== 'ALL') {
            filteredReceptionIds = receptionIds.filter(id => 
                putawayFilter === 'COMPLETED' ? 
                receptionEntities[id].putawayStatus : 
                !receptionEntities[id].putawayStatus
            )
        }

		// Combine and map both data types
		const tableContent = [
			// Map filtered receptions
			...filteredReceptionIds.map(id => ({
				id,
				type: 'reception',
				data: receptionEntities[id]
			})),
			// Map shipments
			...shipmentIds.map(id => ({
				id,
				type: 'shipment',
				data: shipmentEntities[id]
			}))
		].map(item => (
			<Task 
				key={`${item.type}-${item.id}`}
				id={item.id} 
				type={item.type}
				data={item.data}
			/>
		))

		content = (
            <Box sx={{ 
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }}>
                <Box sx={{ 
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start'
                }}>
                    <FormControl sx={{ minWidth: { xs: '100%', sm: 200 } }}>
                        <InputLabel>Putaway Status</InputLabel>
                        <Select
                            value={putawayFilter}
                            label="Putaway Status"
                            onChange={(e) => setPutawayFilter(e.target.value)}
                        >
                            <MenuItem value="ALL">All</MenuItem>
                            <MenuItem value="COMPLETED">Completed</MenuItem>
                            <MenuItem value="PENDING">Pending</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Grid container spacing={1}>
                    {tableContent}
                </Grid>
            </Box>
        )
	}

	return content
}

export default TaskBoard
